import React, {useRef} from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useReactToPrint } from 'react-to-print';

import logo from '../assets/logo_patos.png';

export const DialogPrecos = ({ visible, setVisible, preco }) => {
    const cssText = `
    #print-content {
        font-family: 'Open Sans', sans-serif;
        width: 100%;
        text-align: left;
    }

    img {
            margin-top: 25px;
            width: 100%;
            max-width: 250px;
            height: auto;
            display: block;
        }

        .header-img {
            display: flex;
            justify-content: center;
        }

        .header {
            display: flex;
            align-items: center;
            flex-direction: column;
        }

        .header h2 {
            margin-bottom: 0px;
        }

        .header h4 {
            margin-top: 7px;
        }
    `
    const formatCurrency = (value) => {
        return value.toLocaleString('pt-BR');
    }

    const listaPrecos = preco.map (item => {
        return (
                <tr key={item.id}>
                    <td width="230px" align='center'><span>{item.id !== undefined ? item.id : item[0].id}</span></td>
                    <td width="230px" align='center'> <span>{item.id !== undefined ? item.produto.nome : item[0].produto.nome}</span></td>
                    <td width="230px" align='center'> <span>{item.id !== undefined ? item.produto.embalagem : item[0].produto.embalagem}</span></td>
                    <td width="230px" align='center'> <span> R$ {formatCurrency(item.id !== undefined ? item.valor : item[0].valor)}</span></td>
                    <td width="230px" align='center'> <span>{new Date(item.id !== undefined ? item.data : item[0].data).toLocaleDateString()}</span></td>
                </tr>
        )
    })

    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef, pageStyle: cssText });

    const header = (
        <div>
            <Button label="Imprimir" className="p-button-secondary" icon="pi pi-print" onClick={reactToPrintFn} />
        </div>
    );

    return (
        <Dialog
            visible={visible}
            onHide={() => setVisible(false)}
            header={header}
            className='p-scrollpanel-bar-y'
            breakpoints={{ '960px': '75vw', '640px': '100vw' }}
            style={{ width: '50vw', heigth: '5vw' }}
        >
            {/* {escola.length > 0 ? */}
                <div id="print-content" ref={contentRef}>
                    <div className="p-d-flex p-jc-center header-img">
                    <img style={{width:150, height:150}}
                            id="logo"
                            alt="Logo"
                            src={logo}
                        />
                    </div>
                    <div className="p-d-flex p-ai-center p-flex-column header">
                        <h2>Preços</h2>

                    </div>
                    <table width="100%" border="1" style={{'border-collapse': 'collapse'}} cellpadding="15px" cellspacing="0">
                        <thead>
                            <tr>
                                <th width="100px" ><h2><i>Código</i></h2></th>
                                <th width="100px" ><h2><i>Produto</i></h2></th>
                                <th width="100px" ><h2><i>Embalagem</i></h2></th>
                                <th width="100px" ><h2><i>Valor</i></h2></th>
                                <th width="100px" ><h2><i>Data</i></h2></th>
                            </tr>
                        </thead>

                        <tbody>
                            {listaPrecos}
                        </tbody>


                    </table>

                </div>
        </Dialog>
    );
}
